import type { Variants, Transition } from "framer-motion";

/** Shared easing curve for the premium, calm feel. */
export const EASE_OUT: Transition["ease"] = [0.16, 1, 0.3, 1];

export const SPRING: Transition = { type: "spring", stiffness: 420, damping: 34, mass: 0.7 };

/** Step / panel crossfade-slide used by AnimatePresence. */
export const stepVariants: Variants = {
  initial: { opacity: 0, y: 12 },
  enter: { opacity: 1, y: 0, transition: { duration: 0.32, ease: EASE_OUT } },
  exit: { opacity: 0, y: -8, transition: { duration: 0.18, ease: EASE_OUT } },
};

/** Popover / dropdown enter-exit. */
export const popVariants: Variants = {
  initial: { opacity: 0, y: -6, scale: 0.98 },
  enter: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.16, ease: EASE_OUT } },
  exit: { opacity: 0, y: -6, scale: 0.98, transition: { duration: 0.12, ease: EASE_OUT } },
};

/** Subtle list stagger. */
export const listContainer: Variants = {
  enter: { transition: { staggerChildren: 0.03 } },
};
export const listItem: Variants = {
  initial: { opacity: 0, y: 8 },
  enter: { opacity: 1, y: 0, transition: { duration: 0.25, ease: EASE_OUT } },
};
